import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const providers = [
  { provide: 'BASE_URL', useValue: document.getElementsByTagName('base')[0].href },
  { provide: 'API_URL', useValue: environment.apiUrl },
  { provide: 'BANKID_INTERVAL', useValue: 1000 },
  { provide: 'LOCAL_STORAGE_SESSION_ITEM_NAME', useValue: 'kk_session' }, {
    provide: 'LANGUAGES', useValue: [
      { id: 'se', flag: 'se', name: 'svenska', index: 1 },
      { id: 'en', flag: 'gb', name: 'engelska', index: 2 },
      { id: 'de', flag: 'de', name: 'tyska', index: 3 },
      { id: 'pl', flag: 'pl', name: 'polska', index: 4 },
      { id: 'ar', flag: 'ar', name: 'arabiska', index: 5 }
    ]
  },
  { provide: 'BRAND_NAME', useValue: environment.brandName },
  { provide: 'CREDITOR_BRAND_NAME', useValue: environment.creditorBrandName }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
